import { call, put, takeLatest } from "redux-saga/effects";
import { ApiResponse, RemoveUser, UserPayload } from "models";
import { PayloadAction } from "@reduxjs/toolkit";
import userApi from "api/user";
import { userActions } from "./userSlice";
import { toast } from "react-toastify";

function* getUserList(action: PayloadAction<UserPayload>) {
  try {
    const response: ApiResponse = yield call(
      userApi.getUsersList,
      action.payload
    );
    const data: ApiResponse = response.data;
    if (data.success) {
      yield put(userActions.getUserSuccess(data));
    }
  } catch (error: any) {
    const errorData = error?.response?.data;
    yield put(userActions.getUserFailed(errorData));
  }
}

function* updateUser(action: PayloadAction<UserPayload>) {
  try {
    const response: ApiResponse = yield call(
      userApi.updateUser,
      action.payload
    );
    const data: ApiResponse = response.data;
    if (data.success) {
      toast.success(data.message);
      yield put(userActions.updateUserSuccess(data));
    }
  } catch (error: any) {
    const errorData = error?.response?.data;
    toast.error(errorData?.message || "Something went wrong");
    yield put(userActions.updateUserFailed(errorData));
  }
}

function* deleteUser(action: PayloadAction<RemoveUser>) {
  try {
    const response: ApiResponse = yield call(
      userApi.deleteUser,
      action.payload
    );
    const data: ApiResponse = response.data;
    if (data.success) {
      toast.success(data.success);
      yield put(userActions.deleteUserSuccess(data));
    }
  } catch (error: any) {
    const errorData = error?.response?.data;
    toast.error(errorData?.message || "Something went wrong");
    yield put(userActions.deleteUserFailed(errorData));
  }
}

export default function* userSaga() {
  yield takeLatest(userActions.getUsers.type, getUserList);
  yield takeLatest(userActions.updateUser.type, updateUser);
  yield takeLatest(userActions.deleteUser.type, deleteUser);
}
